import { z } from 'zod'

// Schémas Zod des mutations REST de la double confirmation des factures (règle #7
// CLAUDE.md : toute mutation REST doit être validée par un schéma Zod). Contrat figé dans
// pharmedigroup-api/docs/TRUSTED_DEVICE_2FA.md.

// email-code répond 204 sans corps attendu — schéma vide pour garder la validation Zod
// systématique sur la mutation (même convention que qrLoginTransferActionSchema).
export const deviceConfirmationEmailCodeSchema = z.object({})

export const deviceConfirmationVerifyEmailCodeSchema = z.object({
  code: z.string().length(6),
})

export const securitySettingsUpdateSchema = z.object({
  invoiceDeviceConfirmation: z.boolean(),
})
